import type { MainPoint, SubPoint } from "../../../../types/global"
import { api } from "../../api"

export async function loadSubpoits(): Promise<SubPoint[]> {
    let subpoints = await api<SubPoint[]>("subpoint", {})
    return subpoints.data
}
